import { useEffect, useState } from 'react';
import { listGamepads, type PadListing } from '../../game/controls';

/**
 * The controllers the browser sees, kept current while a screen that lists them is open: a pad
 * appears once a button has been pressed on it, and the one with a button down right now is
 * marked, so two people with the same model can tell which listing is theirs.
 */
export function useGamepads(): PadListing[] {
  const [pads, setPads] = useState<PadListing[]>([]);
  useEffect(() => {
    let frame = 0;
    const poll = () => {
      const next = listGamepads();
      setPads((prev) => (JSON.stringify(prev) === JSON.stringify(next) ? prev : next));
      frame = requestAnimationFrame(poll);
    };
    frame = requestAnimationFrame(poll);
    return () => cancelAnimationFrame(frame);
  }, []);
  return pads;
}
